import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import Notifications from "vue-notification";
import "vue-loading-overlay/dist/vue-loading.min.css";

Vue.config.productionTip = false;

Vue.use(Vuetify);
Vue.use(Notifications);

const lastClear = localStorage.getItem("lastClear");
const now = (new Date()).getTime();

if ((now - lastClear) > 1000 * 60 * 60 * 1) {
  localStorage.clear();
  localStorage.setItem("lastClear", now);
}

if (localStorage.getItem("rompeelmiedo.org") != null) {
  store.commit("setUser", JSON.parse(localStorage.getItem('rompeelmiedo.org')).user)
}

router.beforeEach((to, from, next) => {
  if (to.path != "/login") {
    if (store.state.user.isAuthenticated) {
      next();
    } else {
      next("login");
    }
  } else {
    // console.log(to.path)
    next();
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
